/**
 * Determines whether two arrays of arguments are different. Does not do
 * deep equality checks on arguments that are objects.
 * @param prevArgs
 * @param newArgs
 */
const argsDiffer = (prevArgs, newArgs) => {
    if (prevArgs.length !== newArgs.length) {
        return true;
    }
    for (let i = 0; i < prevArgs.length; i += 1) {
        if (!Object.is(prevArgs[i], newArgs[i])) {
            return true;
        }
    }
    return false;
};
/**
 * Returns a version of the provided function that memoizes only the
 * most recent call. This is similar to the behavior of pure pipes in Angular, with one important difference:
 * When you use a pipe in an Angular template, it creates a new instance of that pipe, and memoized
 * values are not shared across pipe instances. In contrast, if you create a function with memoizeOne and call it in
 * multiple places in a template, the same memoized value will be used in all of them.
 * This utility can be used to create functions that are safe to call in Angular templates
 * because the function won't be recomputed on every change detection cycle if the arguments
 * are the same. Inspired by https://stackblitz.com/edit/angular-ivy-nsq1r9?file=src%2Fapp%2Fapp.component.ts
 * @param fn function to memoize
 */
export const memoizeOne = (fn) => {
    let prevArgs = [];
    let result;
    return function (...newArgs) {
        if (argsDiffer(prevArgs, newArgs)) {
            result = fn(...newArgs);
            prevArgs = newArgs;
        }
        return result;
    };
};
